/**
 * A line saying who you are and whether the server is still there.
 *
 * Separate from the debug HUD behind F3: that one is about frames and
 * triangles, this is about the game being playable at all. A dropped socket is
 * something a player has to be able to see without knowing there is a key that
 * shows counters.
 */
export class StatusBar {
  private readonly root = document.createElement('div');
  private readonly who = document.createElement('span');
  private readonly link = document.createElement('span');
  private readonly notice = document.createElement('span');

  private fade: number | null = null;

  constructor(container: HTMLElement) {
    this.root.className = 'status-bar';
    this.who.className = 'status-who';
    this.link.className = 'status-link';
    this.notice.className = 'status-notice';

    this.root.append(this.who, this.link, this.notice);
    container.appendChild(this.root);
  }

  setPlayer(username: string, online: number): void {
    this.who.textContent = `${username} · w świecie: ${online}`;
  }

  setLink(text: string, tone: 'live' | 'waiting' | 'lost'): void {
    this.link.textContent = text;
    this.link.dataset.tone = tone;
  }

  /**
   * Something the server refused, in passing.
   *
   * Fades on its own: "tam nie da się dojść" is worth saying once, and a
   * message that stays on screen until dismissed would need dismissing after
   * every misclick.
   */
  say(text: string): void {
    this.notice.textContent = text;
    this.notice.classList.add('visible');

    if (this.fade !== null) window.clearTimeout(this.fade);
    this.fade = window.setTimeout(() => this.notice.classList.remove('visible'), 2500);
  }

  dispose(): void {
    if (this.fade !== null) window.clearTimeout(this.fade);
    this.root.remove();
  }
}
